import { useContext } from 'react'
import { RouteContext } from '../../../../components/route-provider'

// This needs to be passed a CVE or a Name for a Static CLI and correctly add to the query params
export const useSearch = () => {
  const { setQueryParameter, clear } = useContext(RouteContext)
  const onSearchInputChanged = (newFilterText: string) => {
    if (newFilterText) {
      setQueryParameter(
        'libraries',
        'filterText',
        newFilterText.replaceAll('%', '')
      )
    } else {
      clear('libraries', 'filterText')
    }
  }
  return {
    onSearchInputChanged
  }
}
